import React from "react";
import { Nav, TabContent } from "reactstrap";
import { compose, withStateHandlers, withHandlers } from "recompose";
import { Page, onMount, NavItem, TabPane } from "components/common";
import { Switch, Redirect } from "react-router-dom";
import TrackingCategoryEdit from "./Edit";
import { Route, Link } from "react-router-dom";
import { Trans } from "react-i18next";

export const TrackingCategoryList = ({
  match,
  categories,
  reloadCategories,
  location,
  ...props
}) => (
  <Page title="Tracking" className="inv-tabs">
    <div className="d-flex mb-2">
      <Link to={`${match.url}/new`} className="btn btn-primary">
        <span className="fa fa-plus mr-2" />
        <Trans>Add Tracking Category</Trans>
      </Link>
    </div>
    <Nav tabs>
      {categories.map((i) => (
        <NavItem
          key={i.TrackingCategoryID}
          to={`${match.url}/${i.TrackingCategoryID}`}
        >
          {i.Name}
        </NavItem>
      ))}
      <Route
        path={`${match.url}/new`}
        render={() => <NavItem to={`${match.url}/new`}>Untitled</NavItem>}
      />
    </Nav>
    <TabContent>
      <div className="d-flex justify-content-start">
        <Switch>
          <TabPane
            key={location.pathname}
            path={`${match.url}/:id`}
            render={(props) => (
              <TrackingCategoryEdit {...props} onSaved={reloadCategories} />
            )}
          />
          {!!categories.length && (
            <Redirect to={`${match.url}/${categories[0].TrackingCategoryID}`} />
          )}
        </Switch>
      </div>
    </TabContent>
  </Page>
);

export const enhance = compose(
  onMount(
    ({ xero }) =>
      () =>
        Promise.props({
          categories: xero.get("trackingcategories").get("data"),
        })
  ),
  withStateHandlers(
    ({ categories }) => ({
      categories,
    }),
    {
      setCategories: () => (categories) => ({ categories }),
    }
  ),
  withHandlers({
    reloadCategories:
      ({ xero, setCategories }) =>
      () => {
        xero.get("trackingcategories").get("data").then(setCategories);
      },
  })
);

export default enhance(TrackingCategoryList);
